export default {
    actions: {
        LOGIN_HOME({commit}, value) {
            commit('setUserHome', value);
        },
        LOGIN_ADMIN({commit}, value) {
            commit('setUserAdmin', value);
        },
        LOGOUT_HOME({commit}, value) {
            commit('removeUserHome', value);
        },
        LOGOUT_ADMIN({commit}, value) {
            commit('removeUserAdmin', value);
        },
        CHANGE_USER_HOME({commit}, value) {
            commit('changeUserHome', value);
        },
        CHANGE_USER_ADMIN({commit}, value) {
            commit('changeUserAdmin', value);
        },
    },

    mutations: {
        setUserHome(state, payload) {
            let userStringify = JSON.stringify(payload.user);
            localStorage.setItem('home_user', userStringify);
            localStorage.setItem('home_token', payload.token);
            state.home_user  = userStringify;
            state.home_token = userStringify;
        },
        setUserAdmin(state, payload) {
            let userStringify = JSON.stringify(payload.user);
            localStorage.setItem('admin_user', userStringify);
            localStorage.setItem('admin_token', payload.token);
            state.admin_user  = userStringify;
            state.admin_token = userStringify;
        },
        removeUserHome() {
            localStorage.removeItem('home_user');
            localStorage.removeItem('home_token');
        },
        removeUserAdmin() {
            localStorage.removeItem('admin_user');
            localStorage.removeItem('admin_token');
        },
        changeUserHome(state, payload) {
            let userStringify = JSON.stringify(payload);
            localStorage.setItem('home_user', userStringify);
            state.home_user  = userStringify;
        },
        changeUserAdmin(state, payload) {
            let userStringify = JSON.stringify(payload);
            localStorage.setItem('admin_user', userStringify);
            state.admin_user  = userStringify;
        }
    },

    state: {
        home_user   : localStorage.getItem('home_user'),
        home_token  : localStorage.getItem('home_token'),
        admin_user  : localStorage.getItem('admin_user'),
        admin_token : localStorage.getItem('admin_token'),
    },

    getters: {
        HOME_USER : function (state) {
            return JSON.parse(state.home_user);
        },
        ADMIN_USER : function (state) {
            return JSON.parse(state.admin_user);
        },
        HOME_TOKEN : function (state) {
            return state.home_token;
        },
        ADMIN_TOKEN : function (state) {
            return state.admin_token;
        }
    }
}